export const ALERT_OPEN = "ALERT_OPEN"
export const ALERT_CLOSE = "ALERT_CLOSE"
